import { createAsyncAction } from 'redux-promise-middleware-actions';
import api from '../Api/apiIS';
import { getActionTypesResult } from '../utils';

export const mobileDevicesConstants = {
    MOBILE_DEVICES_LOADED: 'MOBILE_DEVICES_LOADED',
    MOBILE_DEVICES_CLEARED: 'MOBILE_DEVICES_CLEARED',
    MOBILE_DEVICE_CREATED: 'MOBILE_DEVICE_CREATED',
    MOBILE_DEVICE_UPDATED: 'MOBILE_DEVICE_UPDATED',
    MOBILE_DEVICE_DELETED: 'MOBILE_DEVICE_DELETED',
    MOBILE_DEVICE_ASSIGNED: 'MOBILE_DEVICE_ASSIGNED',
    MOBILE_DEVICE_UNASSIGNED: 'MOBILE_DEVICE_UNASSIGNED',
    MOBILE_DEVICE_GROUP_UPDATED: 'MOBILE_DEVICE_GROUP_UPDATED',
    MOBILE_DEVICES_GROUPED_UNASSIGNED: 'MOBILE_DEVICES_GROUPED_UNASSIGNED',
};

export const mobileDevicesFulfilledConstants = getActionTypesResult(mobileDevicesConstants, '_FULFILLED');
export const mobileDevicesPendingConstants = getActionTypesResult(mobileDevicesConstants, '_PENDING');
export const mobileDevicesRejectedConstants = getActionTypesResult(mobileDevicesConstants, '_REJECTED');

export const clearMobileDevices = () => ({
    type: mobileDevicesConstants.MOBILE_DEVICES_CLEARED
});

export const fetchMobileDevices = createAsyncAction(mobileDevicesConstants.MOBILE_DEVICES_LOADED, query =>
    api
        .get('mobileDevices', {
            params: query,
            paramsSerializer: { indexes: null }
        })
        .then(res => res.data)
);

export const saveMobileDevice = createAsyncAction(mobileDevicesConstants.MOBILE_DEVICE_CREATED, device =>
    api.post('mobileDevices', device).then(res => res.data)
);

export const updateMobileDevice = createAsyncAction(
    mobileDevicesConstants.MOBILE_DEVICE_UPDATED,
    (mobileDeviceId, mobileDevice) => api.put(`mobileDevices/${mobileDeviceId}`, mobileDevice).then(res => res.data)
);

export const groupUpdateMobileDevices = createAsyncAction(mobileDevicesConstants.MOBILE_DEVICE_GROUP_UPDATED, data =>
    api.put(`mobileDevices/bulkUpdate`, data).then(res => res.data)
);

export const deleteMobileDevice = createAsyncAction(mobileDevicesConstants.MOBILE_DEVICE_DELETED, mobileDeviceId =>
    api.delete(`mobileDevices/${mobileDeviceId}`).then(res => res.data)
);

export const assignMobileDevice = createAsyncAction(mobileDevicesConstants.MOBILE_DEVICE_ASSIGNED, (id, data) =>
    api.put(`mobileDevices/${id}/assign`, data).then(res => res.data)
);

export const unassignMobileDevice = createAsyncAction(mobileDevicesConstants.MOBILE_DEVICE_UNASSIGNED, (id, data) =>
    api.put(`mobileDevices/${id}/unassign`, data).then(res => res.data)
);

export const gropedUnassignMobileDevice =
    createAsyncAction(mobileDevicesConstants.MOBILE_DEVICES_GROUPED_UNASSIGNED, data =>
        api.put(`mobileDevices/groupedUnassign`, data).then(res => res.data)
    );
